<pf-loading-overlay />
<div class="app">
    <lib-toastmessage />
    <pf-headermodule [nameOfTheSite]="nameOfTheSite" [logoUrl]="logoUrl" [hasLogo]="true"
        [facebookImgUrl]="facebookImgUrl" [facebookURL]="facebookUrl" [hasFacebookIcon]="true" [hasSearchBar]="false"
        [hasShoppingCart]="true" [hasLogin]="true" [colorOfMobileSidenav]="colorOfMobileSidenav"
        [navigationMenu]="navigationMenu" [hasSubscription]="true" />
    <div class="app-slideshow">
        @if (router.url === '/') {
        <app-slideshow />
        }
    </div>
    <pf-breadcrumbmodule />
    <div class="router">
        <router-outlet />
    </div>
    <pf-footermodule [facebookURL]="facebookUrl" [footer]="footer" />
</div>
<ng-template #footer>
    <div class="elements">
        <div class="multiverzum">
            <a routerLink="/">{{ 'footer.multiverzum' | translate }}</a><br />
        </div>
        <div class="contact-container">
            <div class="contact">
                <div class="span-container">
                    <span>E-mail: {{ this.email }}</span>
                </div>
                <div class="span-container">
                    <span>Cím: {{ this.address }}</span>
                </div>
                <div class="span-container">
                    <span>Telefonszám: {{ this.phoneNumber }}</span>
                </div>
                <!--openingHours is an array now it has only one element, design should have changed after openingHours length > 1, Regenero has this design
        This line is now comma separated, if it has more elements
        -->
                <div class="span-container-opening">
                    <span>Nyitvatartás: {{ this.openingHours }}</span>
                </div>
            </div>
        </div>
        <div class="simple-logo">
            <!--Todo: English version needed for SIMPLE instructions-->
            <a href="http://simplepartner.hu/PaymentService/Fizetesi_tajekoztato.pdf" target="_blank">
                <img src="{{ simplePayLogo }}" title=" SimplePay - Online bankkártyás fizetés"
                    alt=" SimplePay vásárlói tájékoztató" />
            </a>
        </div>
        <br />
        <div class="documents">
            <div class="documents-inside-box">
                <div class="aszf">
                    <a href="{{ aszfUrl }}" class="aszf" target="_blank"><span>{{ 'footer.aszf' | translate
                            }}</span></a>
                </div>
                <div class="privacy-policy">
                    <a href="{{ dataManagamentUrl }}" class="policy" target="_blank"><span>{{ 'footer.policy' |
                            translate }}</span></a>
                </div>
                <div class="subscription">
                    <button mat-raised-button color="primary" type="button" (click)="openSubscriptionDialog()">
                        <mat-icon>mark_as_unread_email_dots</mat-icon>
                        <span class="newsletter-text">{{ 'subscription.subscribe' | translate }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>